import { Box, Grid, TextField, Typography } from "@material-ui/core"
import { Check } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import logoCF from "../../assets/icon-512x512.png"
import { getFatura } from "../../services/comum"
import useLoadingStore from "../../stores/LoadingStore"

export function Faturas() {
    const setLoading = useLoadingStore(s => s.setLoading)
    const { idFatura } = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [fatura, setFatura] = useState(null)

    const faturaPix = async () => {
        setLoading(true)
        try {
            const response = await getFatura(idFatura)

            if (response.retornoErro === 1) {
                console.log(response.mensagem)
                alertStart(response.mensagem, "error")
            } else {
                setFatura(response)
            }
        } catch (error) {
            console.log(error)
            alertStart(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        faturaPix()
    }, [])

    console.log(fatura)

    return (
        <div>
            {fatura && (
                <Grid
                    style={{ margin: "auto", marginTop: "2em" }}
                    xs={11}
                    md={10}
                    lg={10}
                    container
                    spacing={1}
                >
                    <Grid xs={12} md={6} lg={6} item>
                        <Box
                            style={{
                                backgroundColor: "white",
                                padding: "1em",
                                borderRadius: "20px",
                                boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
                            }}
                        >
                            <div
                                style={{
                                    height: "90px",
                                    width: "90px",
                                    textAlign: "center",
                                    margin: "auto",
                                }}
                            >
                                <img src={logoCF} width="100%" height="100%" />
                            </div>
                            <div
                                style={{
                                    lineHeight: "1.6",
                                    marginBottom: "1em",
                                }}
                            >
                                <p style={{ margin: 0 }}>
                                    <span style={{ fontWeight: "bold" }}>Clinete Fiel</span>
                                </p>
                                <p style={{ margin: 0 }}>
                                    CNPJ:{" "}
                                    <span style={{ fontWeight: "bold" }}>09.309.505/0001-07</span>
                                </p>
                                <p style={{ margin: 0 }}>
                                    Comprador:{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                        {fatura?.nomeEstabelecimento}
                                    </span>
                                </p>
                            </div>
                            <hr />
                            <div style={{ marginTop: "1em" }}>
                                <h4>Detalhamento</h4>
                                <p>
                                    ID da fatura:{" "}
                                    <span style={{ fontWeight: "bold" }}>{fatura?.id}</span>
                                </p>
                                <p>
                                    Descrição:{" "}
                                    <span style={{ fontWeight: "bold" }}>{fatura?.descricao}</span>
                                </p>
                                <p>
                                    Valor:
                                    <span style={{ fontWeight: "bold" }}>
                                        {" "}
                                        R$ {fatura?.valor.toFixed(2).replace(".", ",")}
                                    </span>
                                </p>
                                <p>
                                    Status:
                                    <span style={{ fontWeight: "bold" }}> {fatura?.status}</span>
                                </p>
                                <p>
                                    Vencimento:{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                        {(() => {
                                            const [ano, mes, dia] =
                                                fatura?.dataVencimento.split("-")
                                            return `${dia}/${mes}/${ano}`
                                        })()}
                                    </span>
                                </p>
                            </div>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={6} lg={6} item>
                        <Box
                            style={{
                                backgroundColor: "white",
                                padding: "1em",
                                borderRadius: "20px",
                                boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <h4>Forma de pagamento</h4>
                            <hr />
                            <div style={{ display: "flex", gap: "0.5em" }}>
                                <Button
                                    style={{ width: "50%", backgroundColor: "gray" }}
                                    disabled={fatura.status === "PAGA"}
                                >
                                    Pix
                                </Button>
                                <Button
                                    style={{ width: "50%", backgroundColor: "gray" }}
                                    disabled={fatura.status === "PAGA"}
                                    onClick={() => {
                                        window.location.href = fatura?.urlCheckout
                                    }}
                                >
                                    Outras formas de pagamento
                                </Button>
                            </div>
                            {fatura?.status !== "ABERTA" ? (
                                <div style={{ height: "100%", display: "flex" }}>
                                    <Grid
                                        xs={12}
                                        md={6}
                                        lg={6}
                                        style={{
                                            textAlign: "center",
                                            margin: "auto",
                                        }}
                                    >
                                        <Check
                                            style={{
                                                width: "150px",
                                                height: "150px",
                                                color: "green",
                                            }}
                                        />
                                        <Typography
                                            style={{ fontWeight: "bold", fontSize: "1.4em" }}
                                        >
                                            Pagamento realizado
                                        </Typography>
                                    </Grid>
                                </div>
                            ) : (
                                <div>
                                    <Grid
                                        xs={12}
                                        md={6}
                                        lg={6}
                                        style={{
                                            textAlign: "center",
                                            margin: "auto",
                                        }}
                                    >
                                        <img src={fatura?.qrCodePix} width="100%" height="100%" />
                                    </Grid>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        label="Pix"
                                        value={fatura?.qrCodePixText}
                                    />
                                </div>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            )}
        </div>
    )
}
